import { Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";

const CustomStepIconRoot = styled("div")(({ ownerState }) => ({
  backgroundColor: ownerState.active ? "#FFF" : ownerState.completed ? "#00BDFF" : "#326B85",
  zIndex: 1,
  color: "#145A79",
  width: 28,
  height: 28,
  display: "flex",
  borderRadius: "50%",
  justifyContent: "center",
  alignItems: "center",
  border: ownerState.active ? "3px solid #00BDFF" :  "4px solid #145A79",
  transition: "all 0.3s ease",
}));

const CustomStepIcon = (props) => {
  const { active, completed, className, icon } = props;

  return (
    <CustomStepIconRoot ownerState={{ active, completed }} className={className}>
      {completed ? (
        <FontAwesomeIcon icon={faCheck} />
      ) : (
        <Typography variant="caption" color="inherit" sx={{ fontSize: 20, fontWeight: "600" }}>{icon}</Typography>
      )}
    </CustomStepIconRoot>
  )
};

export default CustomStepIcon;